const regexp = {
  mobile: mobile => {
    let reg = new RegExp(/^1[3456789]\d{9}$/);

    return reg.test(mobile);
  },
  email: email => {
    let reg = new RegExp(
      /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
      "g"
    );

    return reg.test(email);
  },
  password: password => {
    var reg = new RegExp(
      /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*]).{8,}$/,
      "g"
    );

    return reg.test(password);
  },
    //只能字母数字组合
    loginOnly: login => {
      let reg = new RegExp(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{2,50}$/);
      return reg.test(login);
    },
  //中文 
  chinese: chinese => {
    var reg = new RegExp(
      /[\u4E00-\u9FA5\uF900-\uFA2D]/,
      "g"
    );

    return reg.test(chinese);
  },
};

export default regexp;